const viewportMixin = {
  data () {
    return {
      viewport: {
        width: 0,
        height: 0
      }
    }
  },

  created () {
    this.computeViewportSize()
    window.addEventListener('resize', this.computeViewportSize)
  },

  methods: {
    computeViewportSize () {
      let e = window
      let a = 'inner'
      if (!('innerWidth' in window)){
          a = 'client'
          e = document.documentElement || document.body
      }
      this.viewport.width  = e[a+'Width']
      this.viewport.height = e[a+'Height']
    }
  }
}

export default viewportMixin
